<template>
  <div>
    <a href="/" class="logo">
      <img src="/media/login/logo.png" alt="logo" />
    </a>
    <h4 class="title">ورود به کاربن</h4>
    <p class="sub-title">برای ورود به کاربن شماره تلفن خود را وارد کنید</p>
    <form @submit.stop.prevent="checkNumber" autocomplete="off">
      <div class="form-row">
        <div class="form-group">
          <i class="icon-phone"></i>
          <input
            type="number"
            name="phone_number"
            class="form-control ltr"
            placeholder="091212345678"
            v-model="phoneNumber"
          />
        </div>
      </div>
      <button type="submit" class="btn btn-primary" ref="login-button">
        <span class="loading-wrapper" ref="login-span">
          <span class="button__text">تایید و ادامه</span>
        </span>
      </button>
    </form>
    <div class="qr-code">
      <p>برای ورود میتوانید رمزینه را از طریق اپلیکیشن اسکن کنید</p>
      <img src="/media/login/qr-code.png" alt="qr-code" />
    </div>
    <div class="apps">
      <p>اپلیکیشن کاربن من را از اینجا دانلود کنید</p>
      <div class="apps-images">
        <a href="#">
          <img src="/media/login/google-play.png" alt="google play" />
        </a>
        <a href="#">
          <img src="/media/login/bazar.png" alt="bazar" />
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  name: "CheckNumber",
  data() {
    return {
      phoneNumber: "",
    };
  },
  methods: {
    checkNumber() {
      this.$emit(
        "submited",
        this.phoneNumber,
        this.$refs["login-span"],
        this.$refs["login-button"]
      );
    },
  },
};
</script>